/**
 * Константы для бизнес-логики
 * Следуют паттернам из старого проекта GitLabCorp
 */

/**
 * Количество копеек в рубле
 * Используется для конвертации цен между копейками и рублями
 */
export const KOPECKS_IN_RUB = 100;

